import { useFormikContext } from 'formik'
import { CourseSearchFormValues } from '../types'

export const useCourseSearchFormContext = () => {
  return useFormikContext<CourseSearchFormValues>()
}
